const tourGuideEnums = new Map();

tourGuideEnums.set('sauda_detail', 1);
tourGuideEnums.set('dispatch_detail', 2);
tourGuideEnums.set('ai_search_homescreen', 3);
export default tourGuideEnums;
